export const departmentFrag = `
    id
    name
    code
    description
`;

export const departmentMutationFrag = `
    id
`;
